export default "__VITE_ASSET__XOzLXVIZ__"